import { type ReactNode, useMemo } from 'react'
import { AssetHubStoreContext, createAssetHubStore } from './store'
import { AssetHubPicker } from './ui'

/**
 * Mount this once in the app frame, wrapping the app's content.
 * Provides the asset hub store to all descendants and renders
 * the picker dialog when opened via `useAssetHub().open()`.
 */
export function AssetHubManager({ children }: { children?: ReactNode }) {
	const store = useMemo(() => createAssetHubStore(), [])

	return (
		<AssetHubStoreContext.Provider value={store}>
			<AssetHubPicker />
			{children}
		</AssetHubStoreContext.Provider>
	)
}
